module.exports = __webpack_public_path__ + "img/step2.bf0f2877.svg";